var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52353 5.7999C5.8549 5.7999 6.12353 5.53127 6.12353 5.1999C6.12353 4.86853 5.8549 4.5999 5.52353 4.5999V5.7999ZM3.15065 5.1999H2.55065V5.7999H3.15065V5.1999ZM3.75065 2.82702C3.75065 2.49565 3.48202 2.22702 3.15065 2.22702C2.81928 2.22702 2.55065 2.49565 2.55065 2.82702H3.75065ZM3.00039 7.9999C3.00039 7.66853 2.73176 7.3999 2.40039 7.3999C2.06902 7.3999 1.80039 7.66853 1.80039 7.9999H3.00039ZM5.52353 5.1999V4.5999H3.15065V5.1999V5.7999H5.52353V5.1999ZM3.15065 5.1999H3.75065V2.82702H3.15065H2.55065V5.1999H3.15065ZM2.40039 7.9999H1.80039C1.80039 11.4241 4.57623 14.1999 8.00039 14.1999V13.5999V12.9999C5.23897 12.9999 3.00039 10.7613 3.00039 7.9999H2.40039ZM8.00039 13.5999V14.1999C11.4246 14.1999 14.2004 11.4241 14.2004 7.9999H13.6004H13.0004C13.0004 10.7613 10.7618 12.9999 8.00039 12.9999V13.5999ZM13.6004 7.9999H14.2004C14.2004 4.57574 11.4246 1.7999 8.00039 1.7999V2.3999V2.9999C10.7618 2.9999 13.0004 5.23848 13.0004 7.9999H13.6004ZM8.00039 2.3999V1.7999C5.70498 1.7999 3.70168 3.04763 2.63051 4.89894L3.14984 5.19943L3.66918 5.49991C4.53466 4.00409 6.15062 2.9999 8.00039 2.9999V2.3999Z",
    fill: "#33363F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5fe4155d0969a74d791ffa83cd0e51b8.svg";
export { ForwardRef as ReactComponent };